module.exports = __webpack_public_path__ + "static/media/icon_kijkwijzer_seks.5249b50e.svg";